import { useState, useRef, useEffect, useContext } from 'react'
import { useSelector } from 'react-redux'
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline'
import { ModalContext } from 'components/Modals/ModalContext'

import ResumeActiveWorkoutCard from 'components/ActiveWorkout/ResumeActiveWorkoutCard'

const LATEST_ACTIVE_WORKOUT_SLICE_VERSION = '8.0.0'

export default function ResumeWorkoutHeader() {

    const dropdownRef = useRef(null)

    const { modalData } = useContext(ModalContext)

    const activeWorkout = useSelector((state) => state.activeWorkout)

    const [isDropdownOpen, setIsDropdownOpen] = useState(false)

    const HandleClickOutsideDropdown = (event) => {

        // If modal is open, don't handle click outside dropdown
        if (modalData !== null) {
            return
        }

        // If click is outside dropdown, close dropdown
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsDropdownOpen(false)
        }
    }

    // Handle dropdown open/close
    useEffect(() => {
        if (isDropdownOpen) {
            document.addEventListener('mousedown', HandleClickOutsideDropdown)
        }

        return () => {
            document.removeEventListener('mousedown', HandleClickOutsideDropdown)
        }
    }, [isDropdownOpen, modalData])

    if (
        activeWorkout.version === LATEST_ACTIVE_WORKOUT_SLICE_VERSION &&
        Array.isArray(activeWorkout.activeWorkouts) &&
        activeWorkout.activeWorkouts.length > 0
    ) {
        return (
            <div className="relative" ref={dropdownRef}>
                <button
                    className="w-full bg-orange-400 text-white px-4 py-2 flex items-center justify-between shadow"
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                    <span className='text-lg font-bold'>
                        {activeWorkout.activeWorkouts.length} Incomplete Workout{activeWorkout.activeWorkouts.length > 1 ? 's' : ''} Active!
                    </span>

                    {isDropdownOpen && <ChevronUpIcon className="w-6 h-6" />}
                    {!isDropdownOpen && <ChevronDownIcon className="w-6 h-6" />}
                </button>

                {isDropdownOpen && (
                    <div className="absolute w-[75%] right-0 p-2 z-50 space-y-2">
                        {activeWorkout.activeWorkouts.map((activeWorkout, index) => (
                            <ResumeActiveWorkoutCard key={index} activeWorkout={activeWorkout} />
                        ))}
                    </div>
                )}
            </div>
        )
    }
}
